export const ENUM_DOMAIN_STATUS = {
    PENDING: 'PENDING',
    LIVE: 'LIVE',
    FAILED: 'FAILED',
};
//# sourceMappingURL=domain-status.enum.js.map